import { render, staticRenderFns } from "./_form.data-loader-entities.page.vue?vue&type=template&id=73f929ba&scoped=true&"
import script from "./_form.data-loader-entities.page.vue?vue&type=script&lang=js&"
export * from "./_form.data-loader-entities.page.vue?vue&type=script&lang=js&"
import style0 from "./_form.data-loader-entities.page.vue?vue&type=style&index=0&id=73f929ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f929ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VForm,VIcon,VLayout})
